import { AppointmentsGroupBy, LocationData } from '../commons';
import { BottomSheetData } from './bottom-sheet-data';

export interface AppointmentsFilterData extends BottomSheetData {
  outsideIntervention?: boolean;
  fitterIntervention?: boolean;
  replacementVehicle?: boolean;
  groupBy?: AppointmentsGroupBy;

  place?: LocationData;
  distance?: number;
  sortBy?: SortingCases;
  date?: Date;
  disabledReplacementVehicle?: boolean;
}

export type SortingCases = 'date' | 'rating';
